import { NgModule } from "@angular/core";
import { SharedModule } from "../components/shared.module";
import { CommonModule } from "@angular/common";
import { PagesRoutingModule } from "./pages-routing.module";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideClientHydration, TransferState } from "@angular/platform-browser";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PagesRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
  ],

  providers: [
    // provideClientHydration(),
    // TransferState
  ]
})
export class PagesModule {}
